import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Form } from 'antd';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { changeListWidth, formatDate, aesMinEncrypt } from '../utils';

// search

class Third extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listWidth: 'calc(87% - 8px)',
      url: '',
    };
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    form: PropTypes.object,
    setPrevPage: PropTypes.func,
    match: PropTypes.object,
  };

  componentDidMount() {
    this.login();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.match.url !== this.props.match.url) {
      setTimeout(() => this.login(), 5);
    }
  }

  login = () => {
    const username = this.props.user.accountName;

    let url = localStorage.getItem('thirdUrl');
    if (url.includes('/reportlist/ct')) {
      const time = formatDate(new Date());
      const str = `${username}#${time}`;
      const token = aesMinEncrypt(str);
      url += `?token=${token}`;
    } else {
      url += `?username=${username}`;
    }

    this.setState({ url });
  };
  render() {
    const { url } = this.state;
    return (
      <div className="form-bg" id="rdscStudy">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader login={false} home={true} />
          <div className="theme-box">
            <div className="box">
              <div className="theme-Third">
                {url && (
                  <iframe
                    title="iframe"
                    style={{ width: '100%', height: '100%', border: 0 }}
                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals"
                    scrolling="auto"
                    src={url}
                  ></iframe>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(Third));
